import { fetch, getIdOrNull } from '..'
import { HttpMethods, makeQueryString } from '../apiHelper'
import { OrderDirections } from '../constants'

export const sendInternshipMessage = (user, { internship, content }) => {
  return fetch(
    '/internship-message/send',
    HttpMethods.POST,
    { internship, content },
    user
  )
}

const DEFAULT_PARAM_GET_MESSAGES = { page: 1, pageSize: 50, unread: false, orderDirection: OrderDirections.DESC }
export const getInternshipsMessages = (user, currentUser, params = DEFAULT_PARAM_GET_MESSAGES) => {
  return fetch(
    `/api/users/${getIdOrNull(currentUser)}/internship-messages${makeQueryString(params)}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const getInternshipMessages = (user, internship) => {
  return fetch(
    `/internship-message/consult/${getIdOrNull(internship)}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const readInternshipMessages = (user, internship) => {
  return fetch(
    '/internship-message/read',
    HttpMethods.POST,
    { internship: getIdOrNull(internship) },
    user
  )
}

export const unreadInternshipMessage = (user, messageId) => {
  return fetch(
    '/internship-message/unread',
    HttpMethods.POST,
    { messageId },
    user
  )
}

export const getInternshipsMessagesCount = (user, params = { ids: [] }) => {
  return fetch(
    `/internships/internship-messages/${makeQueryString(params)}`,
    HttpMethods.GET,
    null,
    user
  )
}
